import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import * as S from "./styled.js";
export const BlogSingle = (props)=>{
    const { title , description , link , date , image , featured , share , tagLabel , ...rest } = props;
    const size = featured ? {
        width: 1200,
        height: 600
    } : {
        width: 450,
        height: 450
    };
    const numberCaracters = featured ? 310 : 130;
    const desc = description && description?.length > numberCaracters ? `${description.slice(0, numberCaracters)}...` : description;
    return /*#__PURE__*/ _jsx(S.BlogSingleContainer, {
        "data-testid": "BlogSingle",
        className: classNames('blog-item__container', {
            'blog-item__container--featured': featured
        }),
        ...rest,
        children: /*#__PURE__*/ _jsxs(S.BlogSingleMain, {
            children: [
                /*#__PURE__*/ _jsxs(S.BlogSingleMainLink, {
                    href: link.href,
                    title: title,
                    target: link.target,
                    children: [
                        /*#__PURE__*/ _jsxs(S.BlogSingleDate, {
                            children: [
                                /*#__PURE__*/ _jsx(S.BlogSingleDay, {
                                    children: date.day
                                }),
                                /*#__PURE__*/ _jsxs(S.BlogSingleMonthAndYear, {
                                    children: [
                                        date.month,
                                        " ",
                                        date.year
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(S.BlogSingleImage, {
                            ...image,
                            resize: size,
                            ...size,
                            isLazy: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(S.BlogSingleContent, {
                    children: [
                        /*#__PURE__*/ _jsx(S.BlogSingleContentLink, {
                            href: link.href,
                            title: title,
                            target: link.target,
                            children: /*#__PURE__*/ _jsxs(S.BlogSingleBlock, {
                                children: [
                                    /*#__PURE__*/ _jsx(S.BlogSingleTitle, {
                                        children: title
                                    }),
                                    desc && /*#__PURE__*/ _jsx(S.BlogSingleDescription, {
                                        children: desc
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(S.BlogSingleFooter, {
                            children: [
                                /*#__PURE__*/ _jsx(S.BlogSingleTagLabel, {
                                    children: tagLabel
                                }),
                                /*#__PURE__*/ _jsx(S.BlogSingleWrapper, {
                                    children: !!share?.length && /*#__PURE__*/ _jsx(S.BlogSingleShareButtons, {
                                        children: share.map((shareItem)=>/*#__PURE__*/ _jsx(S.BlogSingleIconLink, {
                                                href: shareItem.href,
                                                title: shareItem.title,
                                                target: shareItem.target,
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: `nico-${shareItem.icon}`
                                                })
                                            }, shareItem.href))
                                    })
                                }),
                                /*#__PURE__*/ _jsx(S.BlogSingleWrapper, {
                                    children: /*#__PURE__*/ _jsx(S.BlogSingleViewMore, {
                                        children: /*#__PURE__*/ _jsx(S.BlogSingleViewMoreLink, {
                                            href: link.href,
                                            title: link.title,
                                            target: link.target,
                                            children: link.content
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default BlogSingle;

//# sourceMappingURL=index.js.map